import { isLoggedIn } from "../../shared/helper/infoUsuario";
import { launch } from "../../shared/helper/serviceLauncher";
import { MSG_ERRO_SERVIDOR } from "../../shared/constantes/mensagens";
import { obterCampoAdicionalPorSiglaIgnoreCase, obterCampoAdicionalPorTipoDocumento } from "./disponibilidade/helper";
import { obterMensagemPorTipoExigencia } from "./detalhar/helper";
import { obterSiglaTipoPericiaPMF, obterSiglaPericiaAgendavelPMF } from "./pericia/helper";
import isNil from "lodash/isNil";
import configuration from "envConfig";

import { 
  SIGLA_CAMPO_ADICIONAL_DATA_CESSACAO_BENEFICIO, 
  SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO, 
  SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO, 
  SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE, 
  SIGLA_SERVICO_PERICIA_INICIAL_COM_ATESTADO, 
  SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE 
} from "./selecaoServicos/siglaServico";

import {
  SIGLA_CAMPO_POSSUI_DOCUMENTO_MEDICO,
  SIGLA_CAMPO_TIPO_INCAPACIDADE,
  SIGLA_CAMPO_UTILIZAR_ATESTADO_ELETRONICO,
} from "./common/constants/siglasCamposAdicionais";

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/pt-br' 

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const businessSort = (a, b) => {
  let statusA = weightStatus(isTarefa(a) ? a.status : a.situacaoAgendamento);
  let statusB = weightStatus(isTarefa(b) ? b.status : b.situacaoAgendamento);
  return statusA - statusB;
}

export const devePreencherAutodeclaracao = (requerimento) => {
  const requerAutodeclaracao = !!requerimento.requerAutoDeclaracao && requerimento.tipoCanalAtendimento !== 'ENTIDADE_CONVENIADA';
  return requerAutodeclaracao && !requerimento.preenchimentoAutodeclaracaoConcluido;
}

export const podeCumprirExigencia = (requerimento) => {
  // exigencia nao checava usuario logado
  if (!isTarefa(requerimento)) return false;
  return requerimento.status === 'CUMPRIMENTO_DE_EXIGENCIA' && !devePreencherAutodeclaracao(requerimento);
}

export const podeConsultarDescontosParaHerdeiro = (requerimento) => {
  if (requerimento.siglaServico == "CADHERD" && requerimento.status === 'CONCLUIDA') return true;
  return false;
}

export const podeDetalhar = (requerimento) => {
  // detalhar era sempre visivel, incluindo regra do Cumprir substituir o Detalhar (levam ao mesmo lugar)
  // apenas p/ ajudar na regra em que deve ser exibido apenas 03 botoes
  return !podeCumprirExigencia(requerimento);
}

export const podePreencherSES = requerimento => {
  if (!isLoggedIn()) return false;
  if (isTarefa(requerimento)) {
    return (
      requerimento.requerAutoDeclaracao &&
      !requerimento.preenchimentoAutodeclaracaoConcluido &&
      requerimento.status !== "CANCELADA" &&
      requerimento.status !== "CONCLUIDA"
    );
  }
}

export const podeVisualizarSES = requerimento => {
  if (!isLoggedIn()) return false;
  if (isTarefa(requerimento)) {
    return (
      requerimento.requerAutoDeclaracao &&
      (requerimento.preenchimentoAutodeclaracaoConcluido ||
        (requerimento.status === "CANCELADA" &&
          requerimento.status === "CONCLUIDA"))
    );
  }
}

const ehReferenteSeguradoEspecialEPermiteSerCancelado = (requerimento) =>
  requerimento.requerAutoDeclaracao && podeCancelar(requerimento);

export const podeComprovante = requerimento => {
  if (!isLoggedIn()) return false;
  if (isTarefa(requerimento)) {
    return (
      requerimento.status !== "CANCELADA" &&
      requerimento.status !== "CONCLUIDA" &&
      !ehReferenteSeguradoEspecialEPermiteSerCancelado(requerimento) &&
      !(podeCancelar(requerimento) && podeRemarcar(requerimento))
    );
  }
  return requerimento.situacaoAgendamentoPublico !== 'CANCELADO'
    && requerimento.situacaoAgendamentoPublico !== 'CANCELADO_IMPACTADO'
    && !(podeCancelar(requerimento) && podeRemarcar(requerimento))
}

export const podeRelatorio = requerimento => {
  if (!isLoggedIn()) return false;
  return isTarefa(requerimento)
    && (requerimento.status === 'CANCELADA' || requerimento.status === 'CONCLUIDA')
}

export const podeCancelar = requerimento => {
  if (!isLoggedIn()) return false;
  if (isTarefa(requerimento)) {
    return requerimento.status === 'PENDENTE' && requerimento.cancelarHabilitado;
  }
  return requerimento.situacaoAgendamentoPublico === 'AGENDADO' && requerimento.cancelarHabilitado
}

export const podeRemarcar = requerimento => {
  if (!isLoggedIn()) return false;
  return !isTarefa(requerimento)
    && ![30, 31, 40, 41, 50, 51].includes(requerimento.codigoSituacaoAgendamento)
    && requerimento.remarcarHabilitado
}

export const irSelecaoServico = () => {
  let agenda = {
    oldVersionService: "agenda",
    rootPath: 'agenda'
  }
  launch(agenda);
}

const weightStatus = value => {
  switch (value) {
    case 'CUMPRIMENTO_DE_EXIGENCIA':
      return 0;
    case 'REMARCADO':
    case 'AGENDADO':
    case 'REMARCADO_IMPACTADO':
    case 'AGENDADO_IMPACTADO':
      return 1;
    case 'PENDENTE':
      return 2;
    case 'CONCLUIDA':
    case 'CUMPRIDO':
    case 'CUMPRIDO_IMPACTADO':
      return 3;
    case 'CANCELADA':
    case 'CANCELADO':
    case 'CANCELADO_IMPACTADO':
      return 4;
    default:
      return -1;
  }
}

export const isTarefa = requerimento => {
  return !!requerimento.dataPrazo
}

export const getAnoRequerimento = requerimento => {
  if (isTarefa(requerimento)) {
    return dayjs(requerimento.dataUltimaAtualizacao, 'YYYY-MM-DD').format('YYYY')
  } else {
    return dayjs(requerimento.dataAgendamento, 'YYYY-MM-DD').format('YYYY')
  }
}

export const getTextoAuxiliarCumprirExigencia = requerimento => {
  if (devePreencherAutodeclaracao(requerimento)) {
    return "Pedido em exigência, siga para Preencher Autodeclaração.";
  }
  return "Pedido com Exigência, siga para Cumprir Exigência";
}

export const getInfoPlus = requerimento => {
  const status = isTarefa(requerimento) ? requerimento.status : requerimento.situacaoAgendamento;
  const {siglaServico} = requerimento;
  const {SERVICO} = configuration.requerimentoDescontoEntidadesProps;

  switch (status) {
    case 'CUMPRIMENTO_DE_EXIGENCIA':
      return {
        icon: "fas fa-exclamation-triangle",
        color: "#FFCD07",
        type: "Exigência",
        typeAlt: "Em exigência",
        text: getTextoAuxiliarCumprirExigencia(requerimento),
      };
    case 'REMARCADO':
    case 'AGENDADO':
    case 'REMARCADO_IMPACTADO':
    case 'AGENDADO_IMPACTADO':
      return {
        icon: 'fas fa-calendar-alt', color: '#2670E8', type: 'Agendado',
        text: `Pedido com atendimento presencial agendado: ${requerimento.nomeUnidade.toLowerCase()}`,
        complement: `${requerimento.data} ${requerimento.horaAgendamentoAsString}`
      }
    case 'PENDENTE':
      return {
        icon: 'fas fa-hourglass-half', color: '#2670E8', type: 'Análise', typeAlt: 'Em análise',
        text: siglaServico === SERVICO.sigla ? 'Pedido em análise pela Entidade Associativa' : `Pedido em análise pelo INSS`
      }
      case 'CUMPRIDO':
      case 'CUMPRIDO_IMPACTADO':
        return {
          icon: isTarefa(requerimento) ? 'fas fa-check-circle' : 'fas fa-calendar-check',
          color: '#3D4551',
          type: 'Cumprido',
          text: `Aprovado em ${requerimento?.dataUltimaAtualizacao ? formatToBrDate(requerimento?.dataUltimaAtualizacao) : requerimento?.dataHora}`,
        }
    case 'CONCLUIDA':
      return { icon: 'fas fa-check-circle', color: '#268744', type: 'Concluído', text: `Pedido concluído pelo INSS.` }
    case 'CANCELADA':
    case 'CANCELADO':
    case 'CANCELADO_IMPACTADO':
      return { icon: 'fas fa-times-circle', color: '#E60000', type: 'Cancelado', text: `Pedido cancelado, mais informações em Detalhar.` }
    default:
      return { icon: 'fas fa-hourglass-half', color: '#CCCCCC', type: 'Tarefa' }
  }
}

export const getInformacaoStatus = requerimento => {
  const status = isTarefa(requerimento) ? requerimento.status : requerimento.situacaoAgendamento;
  switch (status) {
    case 'CUMPRIMENTO_DE_EXIGENCIA':
      return {
        icon: "fas fa-exclamation-triangle",
        color: "#FFCD07",
        type: "Exigência",
        text: getTextoAuxiliarCumprirExigencia(requerimento),
        subStatus: obterMensagemPorTipoExigencia(requerimento)
      };
    case 'REMARCADO':
    case 'REMARCADO_IMPACTADO':
      return {
        icon: 'fas fa-calendar-minus', color: '#3D4551', type: 'Remarcado',
        text: !isTarefa(requerimento) ? `Solicitado em: ${formatToBrDate(requerimento?.dataAgendamento)}` : `Pedido com atendimento presencial agendado: ${requerimento.nomeUnidade.toLowerCase()}`,
        complement: `${requerimento?.data} ${requerimento?.horaAgendamentoAsString}`,
        subStatus: isTarefa(requerimento) ? `Informação Substatus` : `Compareça à perícia médica no dia ${requerimento?.data} às ${requerimento?.horaAgendamentoAsString}, na APS ${requerimento.nomeUnidade.toUpperCase()}.`
      }
    case 'AGENDADO':
    case 'AGENDADO_IMPACTADO':
      return {
        icon: 'fas fa-calendar-alt', color: '#2670E8', type: 'Agendado',
        text: !isTarefa(requerimento) ? `Solicitado em: ${formatToBrDate(requerimento?.dataAgendamento)}` : `Pedido com atendimento presencial agendado: ${requerimento.nomeUnidade.toLowerCase()}`,
        complement: `${requerimento?.data} ${requerimento?.horaAgendamentoAsString}`,
        subStatus: isTarefa(requerimento) ? `Informação Substatus` : `Compareça à perícia médica no dia ${requerimento?.data} às ${requerimento?.horaAgendamentoAsString}, na APS ${requerimento.nomeUnidade.toUpperCase()}.`
      }
    case 'PENDENTE':
      return {
        icon: 'fas fa-hourglass-half', color: '#2670E8', type: 'Em Análise',
        text: `Solicitado em: ${formatToBrDate(requerimento?.dataCriacao)}`,
        subStatus: `Informação Substatus`
      }
    case 'CONCLUIDA':
      return {
        icon: 'fas fa-check-circle',
        color: '#268744',
        type: 'Concluído',
        text: `Aprovado em ${requerimento?.dataUltimaAtualizacao ? formatToBrDate(requerimento?.dataUltimaAtualizacao) : requerimento?.dataHora}`,
        subStatus: `Informação Substatus`
      }
    case 'CUMPRIDO':
    case 'CUMPRIDO_IMPACTADO':
      return {
        icon: isTarefa(requerimento) ? 'fas fa-check-circle' : 'fas fa-calendar-check',
        color: '#3D4551',
        type: 'Cumprido',
        text: `Aprovado em ${requerimento?.dataUltimaAtualizacao ? formatToBrDate(requerimento?.dataUltimaAtualizacao) : requerimento?.dataHora}`,
        subStatus: `Informação Substatus`
      }
    case 'CANCELADA':
    case 'CANCELADO':
    case 'CANCELADO_IMPACTADO':
      return {
        icon: isTarefa(requerimento) ? 'fas fa-times-circle' : 'fas fa-calendar-times',
        color: isTarefa(requerimento) ? '#E60000' : '#3D4551',
        type: 'Cancelado',
        text: `Cancelado em ${requerimento?.dataUltimaAtualizacao ? formatToBrDate(requerimento?.dataUltimaAtualizacao) : requerimento?.dataHora}`,
        subStatus: `Informação Substatus`
      }
    default:
      return { icon: 'fas fa-hourglass-half', color: '#CCCCCC', type: 'Tarefa' }
  }
}

export const formatCellphoneNumber = phoneNumber => {
  if (!phoneNumber) return null;

  const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
  const match = cleanedPhoneNumber.match(/^(\d{0,2})(\d{0,5})(\d{0,4})$/);
  let formattedNumber = '';

  if (match) {
    formattedNumber += match[1] ? `(${match[1]}` : '(';
    formattedNumber += match[2] ? `) ${match[2]}` : '';
    formattedNumber += match[3] ? `-${match[3]}` : '';
    return formattedNumber;
  }

  return phoneNumber;
};

export const formatPhoneNumber = phoneNumber => {
  if (!phoneNumber) return null;

  const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
  const match = cleanedPhoneNumber.match(/^(\d{0,2})(\d{0,4})(\d{0,4})$/);
  let formattedNumber = '';

  if (match) {
    formattedNumber += match[1] ? `(${match[1]}` : '(';
    formattedNumber += match[2] ? `) ${match[2]}` : '';
    formattedNumber += match[3] ? `-${match[3]}` : '';
    return formattedNumber;
  }

  return phoneNumber;
};

export const formatCEP = cep => {
  if (!cep) return null;

  const cleanedCEP = cep.replace(/\D/g, '');
  const match = cleanedCEP.match(/^(\d{0,2})(\d{0,3})(\d{0,3})$/);
  let formattedCEP = '';

  if (match) {
    formattedCEP += match[1] ? `${match[1]}` : '';
    formattedCEP += match[2] ? `.${match[2]}` : '';
    formattedCEP += match[3] ? `-${match[3]}` : '';
    return formattedCEP;
  }

  return cep;
};

export const removeMask = value => {
  return value ? String(value).replace(/[^0-9]/g, "") : value;
}

export const getContatoTO = (filiadoTO, contato) => {
  let novoFiliadoTO = {
    celular: filiadoTO.celularTO,
    email: filiadoTO.email,
    enderecoContato: montarEnderecoTO(filiadoTO.enderecoPrincipalTO),
    enderecoSecundario: montarEnderecoTO(filiadoTO.enderecoSecundarioTO),
    telefonePrincipal: filiadoTO.telResidencialTO,
    telefoneSecundario: filiadoTO.telComercialTO,
    cpf: filiadoTO.cpf
  };
  let novoContato = {
    celular: {
      ddi: Number(contato.celularTO.ddi),
      ddd: Number(contato.celularTO.numero.slice(0, 2)),
      numero: Number(contato.celularTO.numero.slice(2))
    },
    email: contato.email,
    enderecoContato: montarEnderecoTO(filiadoTO.enderecoPrincipalTO),
    enderecoSecundario: montarEnderecoTO(filiadoTO.enderecoSecundarioTO),
    telefonePrincipal: {
      ddi: Number(contato.whatsappTO.ddi),
      ddd: Number(contato.whatsappTO.numero.slice(0, 2)),
      numero: Number(contato.whatsappTO.numero.slice(2))
    },
    telefoneSecundario: {
      ddi: Number(contato.telResidencialTO.ddi),
      ddd: Number(contato.telResidencialTO.numero.slice(0, 2)),
      numero: Number(contato.telResidencialTO.numero.slice(2))
    },
    cpf: filiadoTO.cpf
  };

  return {
    houveMudanca: notEquals(novoFiliadoTO, novoContato),
    contatoTO: novoContato
  }
}
export const inicializaContatoTO = (filiadoTO) => {
  return {
    concluido: false,
    aceitaNotificacao: '',
    aceitaAcompanhar: '',
    celularTO: {
      ddi: filiadoTO?.celularTO?.ddi ?? '55',
      ddd: filiadoTO?.celularTO?.ddd ?? '',
      numero: filiadoTO?.celularTO?.numero ? filiadoTO?.celularTO?.ddd + '' + filiadoTO?.celularTO?.numero : ''
    },
    whatsappTO: {
      ddi: '55',
      numero: ''
    },
    telResidencialTO: {
      ddi: '55',
      numero: ''
    },
    email: filiadoTO.email,
    enderecoContato: montarEnderecoTO(filiadoTO.enderecoPrincipalTO)
  };
}

function notEquals(obj1, obj2) {
  return JSON.stringify(obj1) !== JSON.stringify(obj2);
}

const montarEnderecoTO = (enderecoTO) => {
  const {
    logradouro,
    numero,
    complemento,
    bairro,
    cep,
    nuMunicipioIBGE,
    csTipoLogradouro
  } = enderecoTO || {};

  return {
    logradouro,
    numero,
    complemento,
    bairro,
    numeroCep: cep,
    municipio: nuMunicipioIBGE,
    tipoLogradouro: csTipoLogradouro,
  };
}

export function isCampoAdicionalVisivel(campo) {
  let isVisivel = campo.visivelSegurado !== false && campo.visivel;
  campo.visivel = isVisivel;
  return campo.visivel;
}

export function dataStringToIso(dataString) {
  let data = dayjs(dataString, 'DD/MM/YYYY').add(3, 'hour')
  return data.toISOString();
}

export function isoDateStringToDate(isoDate) {
  return dayjs(isoDate).tz('America/Sao_Paulo');
}

export const formatToBrDate = date => {
  return date && dayjs.utc(date).format("DD/MM/YYYY");
}
export const formatToBrDateLocale = date => {
  dayjs.locale('pt-br')
  return date && dayjs.utc(date).format("DD/MM/YYYY");
}
export const adicionarDiasComResultadoFormatadoBrDate = (date, quantidadeDias) => {
  return dayjs.utc(date).add(quantidadeDias, 'day').format("DD/MM/YYYY");
}

export const aplicarMascara = (valor, mascara) => {
  let valorFormatado = "";
  let index = 0;

  for (let i = 0; i < mascara.length && index < valor.length; i++) {
    const caracterDaMascara = mascara[i];

    if (caracterDaMascara === "9") {
      valorFormatado += valor[index];
      index++;
    } else {
      valorFormatado += caracterDaMascara;
    }
  }

  return valorFormatado;
};

export const formatarMoeda = (valor) => {
  const apenasDigitos = valor.replace(/\D/g, '');
  const valorNumerico = parseInt(apenasDigitos) / 100;

  if (isNaN(valorNumerico)) {
    return '';
  }

  const valorFormatado = valorNumerico.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  const valorSemSimbolo = valorFormatado.replace('R$', '');
  return valorSemSimbolo.trim();
};

export function montaRequerimentoTO(requerimentoTO) {
  return JSON.stringify({
    dadosRequerente: {
      ...requerimentoTO.dadosRequerente
    },
    servicoSelecionado: requerimentoTO.servicoSelecionado,
    contato: requerimentoTO.contato,
    dadosAdicionais: requerimentoTO.dadosAdicionais,
    anexos: requerimentoTO.anexos,
    vinculos: requerimentoTO.vinculos,
    origemSolicitacao: "INTERNET",
  });
}

// deve ficar em um lugar mais especifico?
export const tratarMensagemDeErro = (error) => {
  if (typeof error === 'string') {
    return error;
  }

  // simplificando os erros gerais, mas poderia ser obtido com:
  // geral (500): erro.response?.data?.mensagem;
  // timeout (503): erro.response?.data === Read timed out
  return MSG_ERRO_SERVIDOR;
}

export const podeAnexarArquivos = (requerimento) => {
  if (!requerimento.servicoSelecionado) return false;
  return requerimento.servicoSelecionado.tipoOperacaoAnexo === 'SIM_CAMPO_DETALHADO'
    || requerimento.servicoSelecionado.tipoOperacaoAnexo === 'SIM_CAMPO_OBRIGATORIO'
    || requerimento.servicoSelecionado.tipoOperacaoAnexo === 'SIM_CAMPO_OPCIONAL';
}

export const formatCPFCNPJ = (documentNumber) => {
  if (!documentNumber) return null;

  const cleanedNumber = documentNumber.replace(/\D/g, '');

  if (cleanedNumber.length > 11) {
    return formatCNPJ(cleanedNumber);
  } else {
    return formatCPF(cleanedNumber);
  }
};

export const formatCPF = (cpf) => {
  const match = cpf.match(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})$/);
  let formattedNumber = '';

  if (match) {
    formattedNumber += match[1] ? `${match[1]}` : '';
    formattedNumber += match[2] ? `.${match[2]}` : '';
    formattedNumber += match[3] ? `.${match[3]}` : '';
    formattedNumber += match[4] ? `-${match[4]}` : '';
  }

  return formattedNumber;
};

export const formatCNPJ = (cnpj) => {
  const match = cnpj.match(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})$/);
  let formattedNumber = '';

  if (match) {
    formattedNumber += match[1] ? `${match[1]}` : '';
    formattedNumber += match[2] ? `.${match[2]}` : '';
    formattedNumber += match[3] ? `.${match[3]}` : '';
    formattedNumber += match[4] ? `/${match[4]}` : '';
    formattedNumber += match[5] ? `-${match[5]}` : '';
  }

  return formattedNumber;
};

export const isPendenteOuEmExigencia = (tarefa) => {
  if (isNil(tarefa?.status)) return false;
  return tarefa.status === 'PENDENTE' ||
    tarefa.status === 'CUMPRIMENTO_DE_EXIGENCIA';
}

export const isConcluidaOuCancelada = (tarefa) => {
  if (!tarefa.status) return false;
  return tarefa.status === 'CONCLUIDA' ||
    tarefa.status === 'CANCELADA';
}

export const isPendenteParaPericia = (tarefa) => {
  if (!tarefa || !tarefa.status || !tarefa.etapaPericia) return false;
  return (tarefa.status === 'PENDENTE' ||
    tarefa.status === 'CUMPRIMENTO_DE_EXIGENCIA')
    && (tarefa.etapaPericia === 'AGUARDANDO_AGENDAMENTO' ||
      tarefa.etapaPericia === 'NAO_COMPARECEU_AGENDAMENTO');
}

export const isExibeAgendarPericia = (tarefa) => {
  return (
    (tarefa?.status === "PENDENTE" || tarefa?.status === "CUMPRIMENTO_DE_EXIGENCIA") &&
    tarefa?.etapaPericia === "AGUARDANDO_AGENDAMENTO"
  );
};

export const isBloqueadoAdicionarAnexoExigencia = (tarefa) => {
  return (
    tarefa?.status === 'CUMPRIMENTO_DE_EXIGENCIA' &&
    tarefa?.servico?.bloquearAnexoExigencia === true
  );
};

export const isBloqueadoAdicionarAnexoPericia = (tarefa) => {
  return (
    tarefa?.status === 'PENDENTE' &&
    (tarefa?.servico?.sigla === SIGLA_SERVICO_PERICIA_INICIAL_COM_ATESTADO || tarefa?.servico?.sigla === SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO)
  );
};

export const isAgendamentoAberto = (agendamento) => {
  const STATUS_AGENDAMENTOS_ABERTOS = [
    'AGENDADO',
    'AGENDADO_IMPACTADO',
    'PENDENTE',
    'CUMPRIMENTO_DE_EXIGENCIA'
  ];
  return STATUS_AGENDAMENTOS_ABERTOS.includes(agendamento.situacaoAgendamento);
}

export const isAgendamentoEncerrado = (agendamento) => {
  const STATUS_AGENDAMENTOS_ENCERRADOS = [
    'REMARCADO',
    'REMARCADO_IMPACTADO',
    'CUMPRIDO',
    'CUMPRIDO_IMPACTADO',
    'CONCLUIDA',
    'CANCELADA',
    'CANCELADO',
    'CANCELADO_IMPACTADO'
  ];
  return STATUS_AGENDAMENTOS_ENCERRADOS.includes(agendamento.situacaoAgendamento);
}

export function formatarTextoInformativo(texto) {
  return texto
    ? texto
      .replace(/<tbody/gi, "<div")
      .replace(/<tr/gi, "<div")
      .replace(/<\/tr>/gi, "</div>")
      .replace(/<td/gi, "<div style='word-wrap: break-word'")
      .replace(/<\/td>/gi, "</div>")
      .replace(/<\/tbody/gi, "</div")
      .replace(/<span/gi, "<div")
      .replace(/<\/span>/gi, "</div>")
      .replace(/<font/gi, "<div")
      .replace(/<\/font>/gi, "</div>")
      .replace(/<div style=/gi, "<div")
      .replace(/<\/div>/gi, "</div>")
    : "";
}

export const obterContatoDoRequente = (tipoContato, contatos) => {
  let valorContato = null;
  if (contatos) {
    let contatoEncontrado = contatos.find((contato) => tipoContato === contato.tipo);
    if (contatoEncontrado) {
      valorContato = contatoEncontrado.valor;
    }
  }
  return valorContato;
}

export const obterSiglaTipoPericiaProrrogacaoParaPMF = (requerimentoTO) => {

  let campoTipoPericiaProrrogacao = obterCampoAdicionalPorSiglaIgnoreCase(
    requerimentoTO?.dadosAdicionais, SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO);
 
  return campoTipoPericiaProrrogacao?.valor ?
    obterSiglaTipoPericiaPMF(campoTipoPericiaProrrogacao?.valor) :
    'INSS_PMANPMF';
}

export const obterSiglaTipoPericiaAgendavelPMF = (requerimentoTO) => {

  let campoTipoPericiaProrrogacao = obterCampoAdicionalPorSiglaIgnoreCase(
    requerimentoTO?.dadosAdicionais, SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO);

  return campoTipoPericiaProrrogacao?.valor ?
    obterSiglaPericiaAgendavelPMF(campoTipoPericiaProrrogacao?.valor) :
    'APMCPMF';
}

export const obterDataUltimoDiaTrabalhado = (requerimentoTO) => {

  let campoCategoriaTrabalhador = obterCampoAdicionalPorSiglaIgnoreCase(
    requerimentoTO.dadosAdicionais, 'CTPB');
  let categoriaTrabalhador = campoCategoriaTrabalhador && 'Empregado' === campoCategoriaTrabalhador.valor ? 1 : 0;

  let dut = null;
  if (categoriaTrabalhador) {
    let campoDUT = obterCampoAdicionalPorTipoDocumento(requerimentoTO.dadosAdicionais, 'DUT');
    dut = campoDUT ? dataStringToIso(campoDUT.valor) : null;
  }

  return dut;
}

export const obterDataCessacaoBeneficio = (requerimentoTO) => {

  let campoDCB = obterCampoAdicionalPorSiglaIgnoreCase(
    requerimentoTO?.dadosAdicionais, SIGLA_CAMPO_ADICIONAL_DATA_CESSACAO_BENEFICIO);

  return campoDCB ? dataStringToIso(campoDCB?.valor) : null;
}

// sera que nao seria melhor eles ficarem em dadosPedidos/helper?
export const obterTipoDeIncapacidade = (requerimentoTO) => {
  const tipoIncapacidade = obterCampoAdicionalPorSiglaIgnoreCase(requerimentoTO?.dadosAdicionais, SIGLA_CAMPO_TIPO_INCAPACIDADE);
  return tipoIncapacidade?.valor;
}

export const isRespondeuQuePossuiDocumentoMedico = (requerimentoTO) => {
  const possuiDocumentoMedico = obterCampoAdicionalPorSiglaIgnoreCase(requerimentoTO?.dadosAdicionais, SIGLA_CAMPO_POSSUI_DOCUMENTO_MEDICO);
  const valor = possuiDocumentoMedico?.valor;
  return valor && valor.toUpperCase() === 'SIM';
}

export const isRespondeuQueDesejaUtilizarAtestadoEletronico = (requerimentoTO) => {
  const desejaUsarAtestadoEletronico = obterCampoAdicionalPorSiglaIgnoreCase(requerimentoTO?.dadosAdicionais, SIGLA_CAMPO_UTILIZAR_ATESTADO_ELETRONICO);
  const valor = desejaUsarAtestadoEletronico?.valor;
  return valor && valor.toUpperCase() === 'SIM' && !desejaUsarAtestadoEletronico.preenchidoPorIntegracao;
}

export const servicoHabilitadoParaDetalharV4 = (siglaServico) => {
  switch( siglaServico ){
    case SIGLA_SERVICO_CONCESSAO_BENEFICIO_INCAPACIDADE:
    case SIGLA_SERVICO_PRORROGACAO_BENEFICIO_INCAPACIDADE:
    case SIGLA_SERVICO_BI_COM_DOCUMENTO_MEDICO:
      return true;
    default:
      return false;
  }
}


export const getInteressado = (interessadosPessoaFisica, interessadosPessoaJuridica, interessadosUnidade) => {
  let lista = (interessadosPessoaFisica || []).concat(interessadosPessoaJuridica || []).concat(interessadosUnidade || [])
  if (!Array.isArray(lista) || lista.length === 0) return null;

  return lista.reduce((menor, atual) => {
    return atual.id < menor.id ? atual : menor;
  });
}


export function extrairDDDNumero(telefone) {
  if (!telefone) return null;
  const apenasNumeros = telefone.replace(/\D/g, '');
  const ddd = parseInt(apenasNumeros.substring(0, 2), 10);
  const celular = apenasNumeros.substring(2);
  return { ddd, celular };
}

export const parseTarefa = (tarefaDetalhada) => {
  if (tarefaDetalhada) {
    const { numeroProtocolo, canalAtendimento, servico, local, localCriacao, interessadosPessoaFisica, interessadosPessoaJuridica, interessadosUnidade } = tarefaDetalhada;
    let tarefa = { ...tarefaDetalhada };
    
    tarefa.protocolo = numeroProtocolo;
    tarefa.nomeServico = servico?.nome;
    tarefa.siglaServico = servico?.sigla;
    tarefa.idServico = servico?.id;
    tarefa.protocoloNomeServico = `${numeroProtocolo} - ${servico?.nome}`;
    tarefa.idLocal = local?.idLocal;
    tarefa.nomeUnidade = local?.descricaoUnidade;
    tarefa.idUnidadeOrganica = local?.idUnidadeOrganica;
    tarefa.codigoUnidade = local?.idUnidadeOrganica ? `${local?.idUnidadeOrganica}` : null;
    tarefa.nomeUnidadeCriacao = localCriacao?.descricaoUnidade;
    let interessado = getInteressado(interessadosPessoaFisica, interessadosPessoaJuridica, interessadosUnidade);
    let contato = interessado?.contatos?.length > 0 ? extrairDDDNumero(interessado?.contatos[0].valor) : {};
    tarefa.idInteressado = interessado?.id;
    tarefa.cpfRequerente = interessado?.cpf;
    tarefa.nomeRequerente = interessado?.nome;
    tarefa.dataNascimentoRequerente = interessado?.dataNascimento;
    tarefa.nomeMaeRequerente = interessado?.nomeMae;
    tarefa.dddCelularRequerente = contato?.ddd;
    tarefa.celularRequerente = contato?.celular;
    tarefa.tipoCanalAtendimento = canalAtendimento;
    return tarefa;
  }
  return null;
}